// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"f3d632a6","178":"6bf1cf17","212":"1f11707d","219":"d5d290da","264":"ccb33fb7","365":"d38e2143","453":"eb23a4df","952":"d42269ae"}[chunkId] + ".chunk.js";
};